exports.onRouteUpdate = ({ location }) => {
  if (!window.gtag) return null;
  const page_path = location.pathname + location.search + location.hash;
  window.gtag("event", "page_view", { page_path });
  return null;
};
